import axiosInstance from './axiosConfig';

export const generateReportApi = (payload) => axiosInstance.post('/reports/generate', payload);
export const getReportsApi = (params) => axiosInstance.get('/reports', { params });

export const downloadReportApi = async (id, fileName) => {
  const response = await axiosInstance.get(`/reports/${id}/download`, { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName || `report-${id}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};